<template>
    <form @submit.prevent="emitSubmit">
        <fieldset :disabled="submitting">
            <div class="form-group">
                <textarea
                    ref="textarea"
                    class="form-control"
                    cols="30"
                    rows="2"
                    required
                    :placeholder="placeholder"
                    v-model="text"
                    @focus="$emit('focus')"
                    @blur="$emit('blur')">
                </textarea>
            </div>
            <div class="form-group">
                <button
                    type="submit"
                    :class="{ 'form-button': true, 'disabled': this.submitting }"
                    v-if="!!text.length">
                    {{ submitText }}
                </button>
                <button
                    type="button"
                    v-if="cancelable"
                    :class="{ 'clear-button': true, 'disabled': this.submitting }"
                    @click="emitCancel">
                    Cancel
                </button>
            </div>
        </fieldset>
    </form>
</template>

<script>
    export default {
        props: {
            placeholder: {
                type: String,
                default: 'Comment...'
            },
            submitText: {
                type: String,
                default: 'Comment'
            },
            cancelable: {
                type: Boolean,
                default: false
            },
            initialText: String
        },

        data() {
            return {
                text: '',
                submitting: false
            };
        },

        mounted() {
            this.text = this.initialText || this.text;
        },

        methods: {
            emitSubmit() {
                if (this.submitting) {
                    return;
                }
                const setSubmitting = submitting => this.submitting = submitting;
                const clearText = () => this.text = '';
                this.$emit('submit', this.text, setSubmitting, clearText);
            },

            emitCancel() {
                if (this.submitting) {
                    return;
                }
                this.$emit('cancel');
            },

            focus() {
                this.$refs.textarea.focus();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .clear-button {
        border: none;
        background: none;
    }

    .form-button {
        background: #33ccff;
        border: #33ccff solid 1px;
        border-radius: 0;
        box-shadow: none;
        box-sizing: border-box;
        color: black;
        display: inline-block;
        font-weight: 400 !important;
        height: 36px;
        line-height: 36px;
        padding: 0 20px;
        text-decoration: none;
        text-shadow: none;
        top: 0; // For when using labels to wrap hidden file inputs
    }
    .form-button:hover {
        background: black;
        color: white;
        border: solid 1px #33ccff;
        outline-offset: 0;
    }

    fieldset {
        .form-button {
            margin-right: 10px;
        }
        .clear-button:hover {
            color: #33ccff;
        }
    }
    fieldset[disabled] {
        textarea {
            color: #b0b0b0 !important;
            border-color: #b0b0b0 !important;
        }
        .form-button {
            background: #555;
            color: #b0b0b0;
            border-color: #aaa;
        }
        button {
            cursor: not-allowed;
        }
    }
</style>



// WEBPACK FOOTER //
// GalleryCommentForm.vue?a40d9354